import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "m-4 px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex sm:items-center" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, "Advanced Search"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "Search for a Document")
    ])
], -1);
const _hoisted_3 = { class: "mt-8" };
const _hoisted_4 = { class: "flex justify-end flex-col sm:flex-row" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", {
    class: "self-center",
    for: "search-select"
}, "Search by:", -1);
const _hoisted_6 = ["value"];
const _hoisted_7 = {
    key: 0,
    class: "flex justify-end ml-2 flex-col sm:flex-row"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "self-center" }, "Date range:", -1);
const _hoisted_9 = { class: "ml-2" };
const _hoisted_10 = { class: "flex mt-2" };
const _hoisted_11 = { class: "relative ml-2 w-full" };
const _hoisted_12 = {
    key: 1,
    class: "flex flex-col"
};
const _hoisted_13 = {
    key: 1,
    class: "flex flex-col"
};
const _hoisted_14 = { class: "flex" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "flex mt-2" };
const _hoisted_17 = ["value"];
const _hoisted_18 = { key: 2 };
const _hoisted_19 = { class: "flex" };
const _hoisted_20 = {
    key: 0,
    class: "mt-8 flex flex-col"
};
const _hoisted_21 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_22 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" };
const _hoisted_23 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_24 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "\n                    Short ID\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Role\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Company Code\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Assigned to\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "\n                    Current stage\n                  ")
    ])
], -1);
const _hoisted_26 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_29 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_30 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_31 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_32 = {
    key: 0,
    class: "text-gray-400 text-center p-8"
};
const _hoisted_33 = { class: "flex justify-center md:justify-end mx-1 md:mx-8 my-4 px-4 md:px-8 py-4 shadow rounded ring-1 ring-black ring-opacity-5" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = ["disabled"];
import { XIcon } from '@heroicons/vue/outline';
import { SearchIcon } from '@heroicons/vue/solid';
import { computed, inject, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import DatePicker from '@/components/DatePicker.vue';
import UserSearch from '@/components/userDropdownSearch.vue';
import { getCompanyCode } from '@/helpers/get-company-code';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdvancedSearch',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const atrs = ref([]);
        const pageNumber = ref(1);
        const atEnd = ref(false);
        const tokens = ref(['']);
        const searched = ref(false);
        const searchQuery = ref('');
        const searchRange = ref([]);
        const searchUser = ref('');
        const searchUserName = ref('');
        const searchOptions = [
            {
                id: 0,
                displayName: 'Hiring Manager',
                value: 'HIRING-MANAGER',
                group: 'HM',
            },
            {
                id: 1,
                displayName: 'First Line Approver',
                value: 'FIRST-LINE-APPROVER',
                group: 'HM',
            },
            {
                id: 2,
                displayName: 'Second Line Approver',
                value: 'SECOND-LINE-APPROVER',
                group: 'HROPS',
            },
            {
                id: 3,
                displayName: 'Admin Owner',
                value: 'ADMIN-OWNER',
                group: 'H2R',
            },
            {
                id: 4,
                displayName: 'Resourcing Owner',
                value: 'RESOURCING-OWNER',
                group: 'RESOURCING',
            },
            {
                id: 5,
                displayName: 'Job Title',
                value: 'JOB-TITLE',
                group: null,
            },
            {
                id: 6,
                displayName: 'Current Stage',
                value: 'USER-BY-STAGE',
                group: null,
            },
        ];
        const selectedSearch = ref(searchOptions[0]);
        const routes = {
            STARTER: 'view-starter',
            LEAVER: 'view-leaver',
            AMEND: 'view-amend',
            OFFER: 'view-offer',
        };
        const stages = inject('stages', []);
        const findStage = (stageName, status) => {
            const foundStage = stages.find((stage) => stage.stageName === stageName);
            if (foundStage)
                return foundStage.displayName;
            return status === 'DRAFT' ? 'Work in progress' : status;
        };
        const currentAssigneeEmail = (atr) => {
            if (atr.currentAssigneeEmail) {
                if (atr.currentAssigneeEmail.includes('@')) {
                    return atr.currentAssigneeEmail;
                }
                if (atr.currentAssignee?.includes('@')) {
                    return atr.currentAssignee;
                }
                return atr.currentAssigneeEmail;
            }
            return 'Unassigned';
        };
        const navigateToDocument = async (id, docOwner) => {
            // find document
            const document = atrs.value.find((atr) => atr.docId === id);
            if (document && document.currentStageName === 'starter.notifyRecruitment') {
                router.push({ path: `/recruitment-team/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRoleAdvertised') {
                router.push({ path: `/advert-raised/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRecruitmentUpdated') {
                router.push({ path: `/recruitment-update/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyCVsCollected') {
                router.push({ path: `/ready-for-selection/${id}/${docOwner}` });
            }
            else if (document &&
                (document.currentStageName === 'starter.notifyCandidateSelected' ||
                    document.currentStageName === 'starter.complete')) {
                router.push({ path: `/selection-complete/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyMakeOffer') {
                router.push({ path: `/offer-hr/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyPrepOffer') {
                router.push({ path: `/confirm/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyTermsHaveChanged') {
                router.push({ path: `/amend-terms/${id}/${docOwner}` });
            }
            else if (document && document.currentStageName === 'offer.notifyH2RAdmin') {
                router.push({ path: `/assign-admin-owner/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyOfferSent') {
                router.push({ path: `/sap-confirmation/${id}/${docOwner}` });
            }
            else {
                router.push({ path: `/${routes[document.docType]}/${id}/${docOwner}` });
            }
        };
        const handleDateChange = (dates) => {
            searchRange.value = dates;
        };
        const handleUser = (event, type) => {
            const { userID, Title } = event;
            searchUser.value = userID;
            searchUserName.value = Title;
            if (type === 'user')
                fetchAtrs();
        };
        const clearUser = () => {
            searchUser.value = '';
            searchUserName.value = '';
            resetSearchSettings();
        };
        const fetchAtrs = async (type = 'next') => {
            store.dispatch('setIsLoading', true);
            const token = type === 'next'
                ? tokens.value[pageNumber.value - 1]
                : tokens.value[pageNumber.value - 3];
            const response = await httpClient.post('/bff/advanced-search', {
                requestedBy: '12345678910',
                searchType: selectedSearch.value.value,
                searchTerm: searchQuery.value,
                searchRange: searchRange.value,
                user: searchUser.value,
                next: token ? token : undefined,
            });
            if (!response.data.body.next) {
                atEnd.value = true;
            }
            else {
                atEnd.value = false;
                tokens.value.push(response.data.body.next);
            }
            atrs.value = response.data.body?.Items ?? [];
            searched.value = true;
            store.dispatch('setIsLoading', false);
        };
        const hideDatePicker = computed(() => selectedSearch.value.value === 'JOB-TITLE' ||
            selectedSearch.value.value === 'USER-BY-STAGE');
        const showUserSearch = computed(() => ['Hiring Manager', 'First Line Approver', 'Second Line Approver'].includes(selectedSearch.value.displayName));
        const showUserSearchAndStage = computed(() => selectedSearch.value.value === 'RESOURCING-OWNER' ||
            selectedSearch.value.value === 'USER-BY-STAGE' ||
            selectedSearch.value.value === 'ADMIN-OWNER');
        const nextPage = async () => {
            if (atEnd.value)
                return;
            pageNumber.value++;
            await fetchAtrs();
        };
        const prevPage = async () => {
            if (pageNumber.value === 1)
                return;
            pageNumber.value--;
            await fetchAtrs('prev');
        };
        const resetSearchSettings = () => {
            atrs.value = [];
            searched.value = false;
            searchQuery.value = '';
            searchRange.value = [];
            searchUser.value = '';
            searchUserName.value = '';
            pageNumber.value = 1;
            atEnd.value = false;
            tokens.value = [''];
        };
        watch(selectedSearch, () => resetSearchSettings());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("select", {
                            id: "search-options-select",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSearch).value = $event)),
                            name: "search-select",
                            class: "mt-1 ml-2 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(searchOptions, (option) => {
                                return _createElementVNode("option", {
                                    key: option.id,
                                    value: option
                                }, _toDisplayString(option.displayName), 9, _hoisted_6);
                            }), 64))
                        ], 512), [
                            [_vModelSelect, selectedSearch.value]
                        ]),
                        _createTextVNode(),
                        (!hideDatePicker.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(DatePicker, {
                                        range: "",
                                        "max-range": 31,
                                        "max-date": new Date(),
                                        "time-picker": false,
                                        value: searchRange.value,
                                        onChange: handleDateChange
                                    }, null, 8, ["max-date", "value"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            (showUserSearch.value)
                                ? (_openBlock(), _createBlock(UserSearch, {
                                    key: 0,
                                    group: selectedSearch.value.group,
                                    onUpdatedUser: _cache[1] || (_cache[1] = ($event) => (handleUser($event, 'user')))
                                }, null, 8, ["group"]))
                                : (showUserSearchAndStage.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (!searchUser.value)
                                            ? (_openBlock(), _createBlock(UserSearch, {
                                                key: 0,
                                                group: selectedSearch.value.group,
                                                onUpdatedUser: _cache[2] || (_cache[2] = ($event) => (handleUser($event, 'stage')))
                                            }, null, 8, ["group"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("input", {
                                                        class: "mt-1 w-full focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-gray-600",
                                                        type: "text",
                                                        value: searchUserName.value,
                                                        disabled: ""
                                                    }, null, 8, _hoisted_15),
                                                    _createTextVNode(),
                                                    _createVNode(_unref(XIcon), {
                                                        class: "text-gray-400 h-5 w-5 hover:text-gray-800 self-center ml-2 cursor-pointer",
                                                        onClick: clearUser
                                                    })
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        id: "stage-options-select",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((searchQuery).value = $event)),
                                                        name: "search-select",
                                                        class: "mt-1 w-full focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-l-md"
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stages), (stage) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: stage.stageName,
                                                                value: stage.stageName
                                                            }, _toDisplayString(stage.displayName), 9, _hoisted_17));
                                                        }), 128))
                                                    ], 512), [
                                                        [_vModelSelect, searchQuery.value]
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "-ml-px mt-1 relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:cursor-not-allowed disabled:text-gray-400 disabled:bg-gray-200",
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (fetchAtrs('next')))
                                                    }, [
                                                        _createVNode(_unref(SearchIcon), {
                                                            class: "h-5 w-5 text-gray-400",
                                                            "aria-hidden": "true"
                                                        }),
                                                        _createTextVNode("\n                  Search\n                ")
                                                    ])
                                                ])
                                            ]))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((searchQuery).value = $event)),
                                                placeholder: "Search...",
                                                type: "text",
                                                class: "mt-1 w-full focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-l-md"
                                            }, null, 512), [
                                                [_vModelText, searchQuery.value]
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "-ml-px mt-1 relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:cursor-not-allowed disabled:text-gray-400 disabled:bg-gray-200",
                                                onClick: _cache[6] || (_cache[6] = ($event) => (fetchAtrs('next')))
                                            }, [
                                                _createVNode(_unref(SearchIcon), {
                                                    class: "h-5 w-5 text-gray-400",
                                                    "aria-hidden": "true"
                                                }),
                                                _createTextVNode("\n                Search\n              ")
                                            ])
                                        ])
                                    ]))
                        ])
                    ])
                ]),
                _createTextVNode(),
                (searched.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("table", _hoisted_24, [
                                        _hoisted_25,
                                        _createTextVNode(),
                                        (atrs.value.length)
                                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atrs.value, (atr, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: atr.docId,
                                                        class: _normalizeClass(index % 2 === 0 ? undefined : 'bg-gray-50')
                                                    }, [
                                                        _createElementVNode("td", {
                                                            class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-blue-600 hover:underline cursor-pointer",
                                                            onClick: ($event) => (navigateToDocument(atr.docId, atr.requestedBy))
                                                        }, _toDisplayString(atr.shortId), 9, _hoisted_27),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_28, _toDisplayString(atr.formThree?.jobTitle
                                                            ? atr.formThree.jobTitle
                                                            : "No role specified"), 1),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(getCompanyCode)(atr)), 1),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_30, _toDisplayString(currentAssigneeEmail(atr)), 1),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_31, _toDisplayString(findStage(atr.currentStageName, atr.status)), 1)
                                                    ], 2));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createTextVNode(),
                                    (!atrs.value.length)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, "\n              No Requests to show...\n            "))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("button", {
                                    class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                    disabled: pageNumber.value === 1,
                                    onClick: prevPage
                                }, "\n            Prev\n          ", 8, _hoisted_34),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                    disabled: atEnd.value,
                                    onClick: nextPage
                                }, "\n            Next\n          ", 8, _hoisted_35)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
